import { createAsyncAction } from '../_helpers/utils'
import { Alert } from '../_services'
import { alertTypes } from '../_constants'

export const loadAlert = createAsyncAction(
    alertTypes.ALERT_REQUEST,
    alertTypes.ALERT_SUCCESS,
    Alert.get
)